/**
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */

import { ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges, ViewEncapsulation } from '@angular/core';

import { PhxDisplayedMark, PhxExtendedMark, PhxMark, PhxMarkLabelAlignment, PhxMarkObj, PhxMarkStyle } from './phx-slider.types';



@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  selector: 'phx-slider-marks',
  template: `
    <div class="phx-slider-mark">
      <span
        class="phx-slider-mark-text"
        *ngFor="let attr of phxMarks; trackBy: trackById"
        [class.phx-slider-mark-active]="attr.active"
        [ngStyle]="attr.style!"
        [innerHTML]="attr.label"
      ></span>
    </div>
  `
})
export class PhxSliderMarksComponent implements OnChanges {

  @Input() phxMarksArray: PhxExtendedMark[] | null = [];
  @Input() phxMin!: number;
  @Input() phxMax!: number;

  phxMarks: PhxDisplayedMark[] = [];

  private labelAlignmentAdjustmentValues: Map<PhxMarkLabelAlignment, string> = new Map([
    ['left', '-100%'],
    ['right', '0%'],
    ['center', '-50%']
  ]);

  ngOnChanges(changes: SimpleChanges): void {
    const { phxMarksArray} = changes;

    if (phxMarksArray) {
      this.buildMarks();
    }
  }

  trackById(_index: number, mark: PhxDisplayedMark): number {
    return mark.value;
  }

  private buildMarks(): void {
    const range = this.phxMax - this.phxMin;

    this.phxMarks = this.phxMarksArray ? this.phxMarksArray.map(mark => {
      const { value, offset, config } = mark;
      const style: PhxMarkStyle = this.getMarkStyles(value, range, config);
      const label = isConfigObject(config) ? config.label : config;

      return {
        label,
        offset,
        style,
        value,
        config,
        active: false
      };
    }) : null;
  }

  private getMarkStyles(value: number, range: number, config: PhxMark): PhxMarkStyle {
    let style;
    const markValue = value;
    const labelAdjustmentValue = this.labelAlignmentAdjustmentValues.get(config.labelAlignment || 'center');
    
    style = {
      transform: `translate3d(${labelAdjustmentValue}, 2px, 0)`,
      left: `${((markValue - this.phxMin) / range) * 100}%`
    };

    return style;
  }
}

function isConfigObject(config: PhxMark): config is PhxMarkObj {
  return typeof config !== 'string';
}